import store from "@/redux/store";

import React, { useState, Suspense, PureComponent } from "react";
import { useParams, useNavigate } from "react-router-dom";

import { connect } from "react-redux";
import { Overview } from "@/views/team/Overview";
import { open, close } from '@/reducers/Window'
import BaseWindow from "@/views/Window/BaseWindow";
//import WindowSearchController from "./Search/WindowSearchController";
import WindowSearchTimeRegistrationController from "./Search/WindowSearchTimeRegistrationController";


class WindowController extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = { windows: [], error: null, isLoaded: false, secret: null, prevType: props.type };
  }

    componentDidMount() {
    }
componentDidUpdate() {
}


  render() {
      const {WindowReducer, windows} = this.props;
      const {hasFocus} = WindowReducer;
      let showWindow = WindowReducer.windows.first();
      let childWindow = null;
      let TestMe;

      let windowPanels = [];
      if(windows.length > 0) {
          windowPanels.push(windows.get().map((window, index) => {
            return window.element;
 
            
            }));
            }
            
            
          return (
            <>
            {windowPanels && windowPanels.length > 0 &&
                <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in">
                </div>
            }
                {windowPanels}
                </>
            
          );  
            
      if(showWindow && showWindow.childWindow) {
        //childWindow = React.lazy(() => import(`${showWindow.childWindow}`));
        let val = '//src/views/base/Buttons/Test.js';
         TestMe = React.lazy(() => import( "@/controllers/Settings/AddTaskController.js" ));
        
      } else {
      } 

    return (
        <>
        
        {TestMe &&
    <BaseWindow key={showWindow.uid} window={showWindow} >
    <Suspense fallback={   (<div> Loading!!!!</div>) }>
        <TestMe />   
    </Suspense>
    
    </BaseWindow>
    }
      </>
      
    );
    }
}

const WindowControllerInit = (props) => {
  return (
    <WindowController
      {...props}
    />
  );
};

function mapStateToProps(state) {
    const {WindowReducer} = state;
  return {
      WindowReducer,
      windows: WindowReducer.windows,
      key: WindowReducer.key
  };
}
export default connect(mapStateToProps)(WindowControllerInit);

